import { AsYouType } from "libphonenumber-js";

const formatTelephoneNumber = (phoneNumber: string) => {
  const AREA_CODE_PREPEND_LENGTH = 4; // Including parentheses
  const asYouType = new AsYouType("PH");
  const inputNumber = asYouType.input(phoneNumber);
  const getChars = asYouType.getChars();
  if (phoneNumber.length > AREA_CODE_PREPEND_LENGTH) {
    return inputNumber; // Return formatted telephone number (with area code in parentheses)
  } else {
    return getChars; // Return plain number
  }
};

const formatMobileNumber = (phoneNumber: string) => {
  const asYouType = new AsYouType("PH");
  // @ts-ignore
  const inputNumber = asYouType.input(phoneNumber);
  const getChars = asYouType.getChars();
  return getChars;
};

export { formatTelephoneNumber, formatMobileNumber };
